export default function QuickSendIcon() {
  return (
    <>
      <svg width="56" height="50" viewBox="0 0 56 50" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M29.7143 1H35.4286" stroke="#505050" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M49.1429 7.28516L52.5714 10.7137" stroke="#505050" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
        <path
          d="M32.5714 30.7146C34.465 30.7146 36 29.1795 36 27.286C36 25.3924 34.465 23.8574 32.5714 23.8574C30.6779 23.8574 29.1429 25.3924 29.1429 27.286C29.1429 29.1795 30.6779 30.7146 32.5714 30.7146Z"
          stroke="#D48136"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path d="M30.1486 29.708L28 31.8566" stroke="#D48136" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M32.5714 1V5.57143" stroke="#505050" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M50.8571 9.00195L47.92 11.9391" stroke="#505050" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M15.4286 25H1.71429" stroke="#D48136" strokeWidth="2" strokeMiterlimit="10" strokeLinecap="round" />
        <path d="M22.2857 31.8574H12" stroke="#D48136" strokeWidth="2" strokeMiterlimit="10" strokeLinecap="round" />
        <path d="M15.4286 38.7148H1.71429" stroke="#D48136" strokeWidth="2" strokeMiterlimit="10" strokeLinecap="round" />
        <path d="M17.7143 38.7148H15.4286" stroke="#D48136" strokeWidth="2" strokeMiterlimit="10" strokeLinecap="round" />
        <path d="M7.42858 31.8574H5.14287" stroke="#D48136" strokeWidth="2" strokeMiterlimit="10" strokeLinecap="round" />
        <path d="M34.9943 24.8609L42.8571 16.998" stroke="#D48136" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
        <path
          d="M17.7143 43.1266C21.6 46.7723 26.8229 49.0008 32.5714 49.0008C44.56 49.0008 54.2857 39.2751 54.2857 27.2866C54.2857 15.298 44.56 5.57227 32.5714 5.57227C22.9714 5.57227 14.8343 11.8008 11.9657 20.4294"
          stroke="#505050"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M22.2857 39.5363C25.0628 41.8677 28.6514 43.2849 32.5714 43.2849C41.4057 43.2849 48.5714 36.1192 48.5714 27.2849C48.5714 24.8277 48.0229 22.5077 47.0286 20.4277"
          stroke="#505050"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </>
  );
}
